import { useBemCN } from '@gik/core/utils/bemBlock';
import React from 'react';
import { ArticlesGrid } from './ArticlesGrid';

type ArticlesGridSkeletonProps = {
  title: string;
};
const blockName = 'articles-grid-skeleton';

export function ArticlesGridSkeleton({ title }: ArticlesGridSkeletonProps) {
  const bem = useBemCN(blockName);

  return <ArticlesGrid {...bem()} articles={Array.from(new Array(4))} title={title} centeredTitle skeleton />;
}
